import { call, put, takeLatest } from "redux-saga/effects";
import { eBoMonActionIds } from "../../action-types/category/IBoMonActions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { boMonApi } from "../../../api/category/boMonApi";

export function* boMonSaga() {
    yield takeLatest(eBoMonActionIds.LOAD_START, loadWorker);
}

function* loadWorker() {
    const res: IBaseResponse = yield call(boMonApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.category.boMon.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.category.boMon.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}